import type { EstimatedAccruedRewards, EstimatedTradingReward } from '$lib/types/rewards';
import type { Season, SeasonIdentifiers, userSeasonData } from '$lib/types/tradingRewards';
import { writable, type Readable, type Writable, derived } from 'svelte/store';
import { currentSeason } from './tradingRewardsConfig';
import { browser } from '$app/environment';

export const loadingRewards: Writable<boolean> = writable(false);
export const estimatedAccruedRewards: Writable<EstimatedAccruedRewards> = writable();

export const loadingTradeReward: Writable<boolean> = writable(false);
export const estimatedTradeReward: Writable<EstimatedTradingReward> = writable();

export const loadingTradeRewardClosePosition: Writable<boolean> = writable(false);
export const estimatedTradeRewardClosePosition: Writable<EstimatedTradingReward> = writable();

export const loadingSelectedSeason: Writable<boolean> = writable(false);
export const seasons: Writable<Record<SeasonIdentifiers, Season>> = writable();
export const selectedSeasonIdentifier: Writable<SeasonIdentifiers> = writable(currentSeason);
export const selectedSeason: Readable<Season | undefined> = derived(
	[seasons, selectedSeasonIdentifier],
	([$seasons, $selectedSeasonIdentifier]) => {
		if (
			$seasons &&
			$seasons.hasOwnProperty($selectedSeasonIdentifier) &&
			$selectedSeasonIdentifier
		) {
			return $seasons[$selectedSeasonIdentifier];
		} else {
			return undefined;
		}
	}
);
export const currentSeasonObject: Readable<Season | undefined> = derived(
	[seasons],
	([$seasons]) => {
		if ($seasons && $seasons.hasOwnProperty(currentSeason)) {
			return $seasons[currentSeason];
		} else {
			return undefined;
		}
	}
);

export const loadingUserSeasonStats: Writable<boolean> = writable(false);
export const userSeasonStats: Writable<userSeasonData> = writable();

//map with address and last level shown
export const modalLastLevelShown: Writable<Record<string, number>> = writable(
	JSON.parse(browser ? localStorage.getItem('modalLastLevelShown') || '{}' : '{}')
);
if (browser)
	modalLastLevelShown.subscribe(
		(value) => (localStorage.modalLastLevelShown = JSON.stringify(value))
	);

export const ongoingCompetitions: Readable<Array<string>> = derived(
	[currentSeasonObject],
	([$currenSeasonObject]) => {
		if ($currenSeasonObject) {
			let ongoingCompetitionsTemp: Array<string> = [];
			$currenSeasonObject.levels.forEach((l) => {
				ongoingCompetitionsTemp = ongoingCompetitionsTemp.concat(l.ongoingCompetitions);
			});
			let uniqueOngoingCompetitionsTemp = [...new Set(ongoingCompetitionsTemp)];
			return uniqueOngoingCompetitionsTemp;
		} else {
			return [];
		}
	}
);

export const upcomingCompetitions: Readable<Array<string>> = derived(
	[currentSeasonObject],
	([$currenSeasonObject]) => {
		if ($currenSeasonObject) {
			let upcomingCompetitionsTemp: Array<string> = [];
			$currenSeasonObject.levels.forEach((l) => {
				upcomingCompetitionsTemp = upcomingCompetitionsTemp.concat(l.upcomingCompetitions);
			});
			let uniqueUpcomingCompetitionsTemp = [...new Set(upcomingCompetitionsTemp)];
			return uniqueUpcomingCompetitionsTemp;
		} else {
			return [];
		}
	}
);

export const pastCompetitions: Readable<Array<string>> = derived(
	[currentSeasonObject],
	([$currenSeasonObject]) => {
		if ($currenSeasonObject) {
			let pastCompetitionsTemp: Array<string> = [];
			$currenSeasonObject.levels.forEach((l) => {
				pastCompetitionsTemp = pastCompetitionsTemp.concat(l.pastCompetitions);
			});
			let uniquePastCompetitionsTemp = [...new Set(pastCompetitionsTemp)];
			return uniquePastCompetitionsTemp;
		} else {
			return [];
		}
	}
);

//Notifications acknowledged for upcoming competitions
export const notificationsClosedForOngoingCompetitions: Writable<Array<string>> = writable(
	JSON.parse(
		browser ? localStorage.getItem('notificationsClosedForOngoingCompetitions') || '[]' : '[]'
	)
);

if (browser)
	notificationsClosedForOngoingCompetitions.subscribe((value) => {
		localStorage.notificationsClosedForOngoingCompetitions = JSON.stringify(value);
	});

//Notifications to show for upcoming competitions

export const notificationsToShowForOngoingCompetitions: Readable<Array<string>> = derived(
	[notificationsClosedForOngoingCompetitions, ongoingCompetitions],
	([$notificationsClosedForOngoingCompetitions, $ongoingCompetitions]) => {
		if (browser) {
			let ans: Array<string> = $ongoingCompetitions.filter(
				(uc) => !$notificationsClosedForOngoingCompetitions.includes(uc)
			);
			return ans;
		} else {
			return [];
		}
	}
);
